module.exports = __webpack_public_path__ + "static/media/inox-img.323a017a.png";